import React, { useMemo } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { BlockStack, Text } from "@shopify/polaris";

/** Toolbar: bold / italic / underline, quote, lists, text & highlight colour, link, clear — Quill is BSD-licensed (free). */
const QUILL_FORMATS = [
  "bold",
  "italic",
  "underline",
  "blockquote",
  "list",
  "bullet",
  "color",
  "background",
  "link",
];

/**
 * @param {{
 *   label?: React.ReactNode;
 *   value: string;
 *   onChange: (html: string) => void;
 *   placeholder?: string;
 * }} props
 */
export default function PrivacyPolicyRichTextEditor({
  label = "Privacy policy text",
  value,
  onChange,
  placeholder = "Privacy policy",
}) {
  const modules = useMemo(
    () => ({
      toolbar: [
        ["bold", "italic", "underline"],
        ["blockquote"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ color: [] }, { background: [] }],
        ["link"],
        ["clean"],
      ],
    }),
    [],
  );

  return (
    <BlockStack gap="150">
      {label ? (
        typeof label === "string" ? (
          <Text as="p" variant="bodyMd" fontWeight="semibold">
            {label}
          </Text>
        ) : (
          <div>{label}</div>
        )
      ) : null}
      <div className="age-privacy-quill-wrap">
        <ReactQuill
          theme="snow"
          value={value ?? ""}
          onChange={onChange}
          modules={modules}
          formats={QUILL_FORMATS}
          placeholder={placeholder}
        />
      </div>
      <style>{`
        .age-privacy-quill-wrap .ql-toolbar.ql-snow {
          border: none;
          border-bottom: 1px solid #c9cccf;
          border-radius: 0;
          font-family: inherit;
        }
        .age-privacy-quill-wrap .ql-container.ql-snow {
          border: none;
          font-family: inherit;
        }
        .age-privacy-quill-wrap .ql-editor {
          min-height: 120px;
        }
      `}</style>
    </BlockStack>
  );
}
